import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axiosInstance from "../../api/axiosInstance";
import useStateRef from "react-usestateref";
import { notification } from "antd";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
// Mui meterial component import
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import "./Profile.css";
import HeaderMasterComponent from "../Header/HeaderMaster";
import FooterMaster from "../Dashboard/FooterMaster";

import alertModelTickImg from "../../assets/Images/alert.svg";
import successModelTickImg from "../../assets/Doctor_web_Icon/success.svg";
import vector from "../../assets/Doctor_web_Icon/Vector.png";
import add_icon from "../../assets/Doctor_web_Icon/Add.svg";
import EmailIcon from "../../assets/icon/EmailIcon.svg";
import WebSiteIcom from "../../assets/icon/websiteIcon.svg";
import PhoneIcon from "../../assets/icon/PhoneIcon.svg";
import LoactionIcon from "../../assets/icon/LoactionIcon.svg";
import logoutIcon from "../../assets/Doctor_web_Icon/Group 23875.svg";
import BackIcon from "../../assets/Doctor_web_Icon/Group 31.svg";
import Card from "@mui/material/Card";
import { MenuItem, Container } from '@mui/material';
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Cookies from "js-cookie";

import { HiOutlineChevronLeft, HiOutlineUser, HiOutlineDocumentText, HiOutlineAcademicCap, HiOutlineIdentification, HiOutlinePlus, HiOutlineX, HiOutlineExternalLink } from 'react-icons/hi';
import moment from "moment";
import { decryptAESKey, setupKeys, encryptData, decryptData } from '../Crypto_Helpers/cryptoHelper';
import { initEncryptionSession } from '../../encryptionSession';


function ProfileComponent() {
  let Var_History = useHistory();

  const [Var_ShowImage, setVar_ShowImage] = React.useState(false);
  const [Var_Profiledata, setVar_Profiledata, Var_Profiledata_Ref] =
    useStateRef([]);
  const [Var_ProfileImg, setVar_ProfileImg, Var_ProfileImg_Ref] = useStateRef("");
  const [Var_TitleType, setVar_TitleType, Var_TitleType_Ref] = useStateRef("Dr.");
  const [Var_RegNo, setVar_RegNo, Var_RegNo_Ref] = useStateRef("");
  const [Var_Experience, setVar_Experience, Var_Experience_Ref] = useStateRef("");
  const [Var_Languages, setVar_Languages, Var_Languages_Ref] = useStateRef("");
  const [Var_Location, setVar_Location, Var_Location_Ref] = useStateRef("");
  const [Var_Conditions, setVar_Conditions, Var_Conditions_Ref] = useStateRef([]);
  const [Var_Procedures, setVar_Procedures, Var_Procedures_Ref] = useStateRef([]);
  const [conditionInput, setConditionInput] = useState("");
  const [procedureInput, setProcedureInput] = useState("");
  const [Var_Documents, setVar_Documents, Var_Documents_Ref] = useStateRef({
    license: "",
    authorizedSignature: "",
    commercialLicense: "",
    civilId: ""
  });
  const [Var_SinceData, setVar_SinceData, Var_SinceData_Ref] = useStateRef("");
  const [Var_EmailData, setVar_EmailData, Var_EmailData_Ref] = useStateRef("");
  const [Var_Quali, setVar_Quali, Var_Qauli_Ref] = useStateRef("");
  const [Var_nation, setVar_nation, Var_Nation_Ref] = useStateRef("");
  const [Var_Self, setVar_Self, Var_Self_Ref] = useStateRef("");
  const [Var_WebsiteData, setVar_WebsiteData, Var_WebsiteData_Ref] = useStateRef("");
  const [Var_MobileData, setVar_MobileData, Var_MobileData_Ref] = useStateRef("");
  const [Var_AddressData, setVar_AddressData, Var_AddressData_Ref] = useStateRef("");
  const [DOB, setDOB, Var_DOB] = useStateRef("");
  const [Var_Gender, setVar_Gender, Var_Gender_Ref] = useStateRef("");
  const [loading, setLoading] = useState(true);


  const [Var_ProfileSuccessfully, setVar_ProfileSuccessfully] = useStateRef("");
  const [Var_ShowResults, setVar_ShowResults] = React.useState(true);
  const [Var_IsShowSuccess, setVar_IsShowSuccess] = React.useState(false);
  const [Var_IsShowSuccessmodal, setVar_IsShowSuccessmodal] =
    React.useState(false);
  const [Var_IsShowDeletePostModel, setVar_IsShowDeletePostModel] =
    React.useState(false);
  const [Var_PharmacyDetials, setVar_PharmacyDetials, Var_PharmacyDetials_Ref] =
    useStateRef([]);
  const [Var_pharmdataSelect, setVar_pharmdataSelect, Var_pharmdataSelect_ref] =
    useStateRef("");
  const [Var_pharmacyId, setVar_pharmacyId, Var_pharmacyId_Ref] = useStateRef(
    []
  );
  const [Var_GetServiceList, setVar_GetServiceList, Var_GetServiceList_Ref] = useStateRef([]);
  const [Var_SpecialityValueId, setVar_SpecialityValueId] = useStateRef("");
  const [isshowWebAccess, setisshowWebAccess] = useStateRef(false);
  const [checkboxValues, setcheckboxValues] = useStateRef({
    appointment_access: false,
    service_access: false,
    workinghrs_access: false,
    revenue_access: false
  });

  // initial function call start
  useEffect(() => {
    getDoctorProfile();
    getSpeciality();
    getWebAccessDetials();
  }, []);
  // initial function call end

  const logoutModal = () => {
    setVar_IsShowDeletePostModel(!Var_IsShowDeletePostModel);
  };

  const logout = (path) => {
    Var_History.push(path);
  };

  const localDataClear = () => {
    Cookies.remove("LoginData");
    Cookies.remove("clinic_name");
    Cookies.remove("Clinic_id");
    Cookies.remove("clinic_id");
    Cookies.remove("clinic_vendor_type_id");
    Cookies.remove("Doctor_id");
    Cookies.remove("doctor_id");
    Cookies.remove("speciality_Id");
    Cookies.remove("tokenHeader");
    Cookies.remove("tokenExpiry");
    localStorage.removeItem("LoginData");
    localStorage.removeItem("clinic_name");
    localStorage.removeItem("clinic_id");
    localStorage.removeItem("clinic_vendor_type_id");
    localStorage.removeItem("doctor_id");
    localStorage.removeItem("speciality_Id");
    localStorage.removeItem("isChangeClinic");
  };

  // navigation to back start
  const handleOnClick = (path) => {
    Var_History.push("/dashboard" + path);
  };
  // navigation to back end

  // profile model controls start
  const isCloseProfileSuccessModel = () => {
    setVar_IsShowSuccess(!Var_IsShowSuccess);
  };
  // profile model controls end

  const successClose = () => {
    setVar_IsShowSuccess(!Var_IsShowSuccess);
  };

  const noDeletePostModel = (data) => {
    setVar_IsShowDeletePostModel(!Var_IsShowDeletePostModel);
  };

  const yesDeletePostModel = (path) => {
    localDataClear();
    setVar_IsShowDeletePostModel(!Var_IsShowDeletePostModel);
    setVar_IsShowSuccessmodal(!Var_IsShowSuccessmodal);
  };
  const logoutsuccess = (path) => {
    setVar_ProfileSuccessfully("Logout successful.");
    setVar_IsShowSuccess(true);
    setTimeout(() => {
      setVar_IsShowSuccess(false);
      localDataClear();
      logout(path);
    }, 3000);
  };

  //File upload methods start
  const uploadImage = () => {
    setVar_ShowImage(!Var_ShowImage);
    setVar_ShowResults(!Var_ShowResults);
  };
  const getVar_MobileData = (value) => {
    const numericOnly = value.replace(/\D/g, "");
    setVar_MobileData(numericOnly);
  };
  const getDoctorId = () => {
    let docId = Cookies.get("Doctor_id") || Cookies.get("doctor_id") || localStorage.getItem("Doctor_id") || localStorage.getItem("doctor_id");
    if (!docId) {
      try {
        const loginDataRaw = Cookies.get("LoginData") || localStorage.getItem("LoginData");
        if (loginDataRaw) {
          const parsed = JSON.parse(loginDataRaw);
          docId = parsed?.vendor_id || parsed?.id || parsed?.doctor_id;
          if (docId) {
            Cookies.set("Doctor_id", docId, { expires: 1 });
          }
        }
      } catch (e) {
        console.warn("Could not parse LoginData", e);
      }
    }
    return docId;
  };

  const uploadDocument = async (e) => {
    if (!e.target.files || !e.target.files[0]) return;
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("module_id", "1");
      formData.append("file", e.target.files[0]);
      formData.append("pathLocation", "PROFILE/");
      const response = await axiosInstance.post("doctor/awsS3FileUpload", formData);
      let resData = response.data?.data;
      if (typeof resData === "string") {
        const aesKey = await initEncryptionSession();
        resData = await decryptData(resData, aesKey);
      }
      if (resData?.url) {
        setVar_ProfileImg(resData.url);
      }
    } catch (error) {
      console.log("Upload error:", error);
    } finally {
      setLoading(false);
    }
  };
  //File upload methods end

  const defaultPharmacy = {
    vendor_name: "Select Pharmacy",
    pharmacyId: "",
  };

  const walkinMobileNumbetValidation = (event) => {
    let numericonly = event.target.value.replace(/[^0-9.]/g, '');
    if (/^\d{0,10}$/.test(event.target.value)) {
      setVar_MobileData(numericonly);
    }
  };

  //Get Web Access details
  const getWebAccessDetials = async () => {
    setLoading(true);
    try {
      const docId = getDoctorId();
      const clinicId = Cookies.get("Clinic_id") || Cookies.get("clinic_id");
      const requestData = {
        doctorId: docId,
        clinicId: clinicId,
      };
      const response = await axiosInstance.post("doctor/clinicTabPermissionbyId", requestData);
      setisshowWebAccess(false);
      let resData = response.data?.data;
      if (typeof resData === "string") {
        const aesKey = await initEncryptionSession();
        resData = await decryptData(resData, aesKey);
      }
      if (Array.isArray(resData) && resData[0]) {
        setcheckboxValues({
          appointment_access: resData[0].appointment_access == 1,
          service_access: resData[0].service_access == 1,
          revenue_access: resData[0].revenue_access == 1,
          workinghrs_access: resData[0].workinghrs_access == 1,
        });
      }
    } catch (error) {
      setisshowWebAccess(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  //Get Profile Details List start
  const getDoctorProfile = async () => {
    setLoading(true);
    try {
      const docId = getDoctorId();
      if (!docId) {
        console.warn("No doctorId found");
        setLoading(false);
        return;
      }
      let profileGetData = {
        doctorId: docId,
        doctor_id: docId
      };
      const response = await axiosInstance.post("doctor/getDoctorDetails", profileGetData);

      let rawData = response?.data?.data;
      if (typeof rawData === "string") {
        const aesKey = await initEncryptionSession();
        rawData = await decryptData(rawData, aesKey);
      }
      const dataArr = Array.isArray(rawData) ? rawData : (rawData ? [rawData] : []);
      setVar_Profiledata(dataArr);

      if (dataArr.length > 0) {
        const item = dataArr[0];
        setVar_ProfileImg(item.vendor_profile_path || item.profile_path || item.profileImage || "");
        setVar_TitleType(item.titleType || item.title_type || "Dr.");
        setVar_RegNo(item.regNumber || item.reg_no || "");
        const expStr = item.vendor_experience || (item.experience !== undefined && item.experience !== null ? String(item.experience) : "");
        setVar_Experience(expStr.replace(/\D/g, '') || expStr);
        setVar_Location(item.location || item.vendor_location || "");
        setVar_SinceData(item.practiceSince || item.practice_since || "");
        setVar_EmailData(item.email || item.vendor_email || item.vendor_contact_email || "");
        setVar_nation(item.nationality || "");
        setVar_Self(item.selfDescription || item.self_description || item.vendor_selfDes || "");
        setVar_Languages(item.languages || "");
        setVar_Quali(item.qualification || item.vendor_contact_qualification || "");
        setVar_WebsiteData(item.website || item.vendor_website || "");
        setVar_MobileData(item.mobile || item.phone || item.vendor_phone || item.vendor_contact_mobile || "");
        setDOB(item.dob || "");
        setVar_Gender(item.gender || item.vendor_contact_gender || "");
        setVar_AddressData(item.vendor_address || item.address || item.clinic_address || "");
        setVar_Conditions(Array.isArray(item.conditions) ? item.conditions : []);
        setVar_Procedures(Array.isArray(item.procedures) ? item.procedures : []);
        setVar_Documents({
          license: item.license || item.licence_path || "",
          authorizedSignature: item.authorizedSignature || item.authorized_signature_path || "",
          commercialLicense: item.commercialLicense || item.commercial_licence_path || "",
          civilId: item.civilId || item.civil_id_path || ""
        });

        if (Array.isArray(item.speciality) && item.speciality.length > 0) {
          const spec = item.speciality[0];
          setVar_SpecialityValueId({
            id: spec.specialityId || spec.id,
            speciality: spec.speciality || spec.speciality_name || spec.name
          });
        }

        const pharmaRaw = item.pharma_list;
        const pharmaListData =
          typeof pharmaRaw === "string"
            ? JSON.parse(pharmaRaw)
            : Array.isArray(pharmaRaw)
              ? pharmaRaw
              : [];

        setVar_pharmdataSelect(
          pharmaListData.length > 0 ? pharmaListData[0] : defaultPharmacy
        );
        if (pharmaListData.length > 0) {
          Cookies.set("pharmacy_id", pharmaListData[0].pharmacyId, { expires: 1 });
        } else {
          Cookies.set("pharmacy_id", "");
          getPharmacyDetials();
        }
      }
    } catch (error) {
      console.log("Profile error:", error);
    } finally {
      setLoading(false);
    }
  };
  //Get Profile Details List end

  // Condition and procedure handlers
  const handleAddCondition = (e) => {
    if (e) e.preventDefault();
    const val = conditionInput.trim();
    if (!val) return;
    const currentList = Var_Conditions_Ref.current || [];
    if (!currentList.includes(val)) {
      setVar_Conditions([...currentList, val]);
    }
    setConditionInput("");
  };

  const handleRemoveCondition = (indexToRemove) => {
    const currentList = Var_Conditions_Ref.current || [];
    setVar_Conditions(currentList.filter((_, idx) => idx !== indexToRemove));
  };

  const handleAddProcedure = (e) => {
    if (e) e.preventDefault();
    const val = procedureInput.trim();
    if (!val) return;
    const currentList = Var_Procedures_Ref.current || [];
    if (!currentList.includes(val)) {
      setVar_Procedures([...currentList, val]);
    }
    setProcedureInput("");
  };

  const handleRemoveProcedure = (indexToRemove) => {
    const currentList = Var_Procedures_Ref.current || [];
    setVar_Procedures(currentList.filter((_, idx) => idx !== indexToRemove));
  };

  //Edit Profile Details List start
  const editDoctorProfile = async () => {
    if (Var_AddressData_Ref.current == "") {
      notification.error({ message: "Enter Address" });
    } else if (Var_MobileData_Ref.current == "") {
      notification.error({ message: "Enter Mobile Number" });
    } else {
      setVar_ShowResults(!Var_ShowResults);
      setLoading(true);
      const docId = getDoctorId();
      let profileEditData = {
        doctorId: docId,
        gender: Var_Gender_Ref.current,
        titleType: Var_TitleType_Ref.current,
        regNumber: Var_RegNo_Ref.current,
        experience: Var_Experience_Ref.current,
        location: Var_Location_Ref.current,
        practiceSince: Var_SinceData_Ref.current,
        mobile: Var_MobileData_Ref.current,
        email: Var_EmailData_Ref.current,
        address: Var_AddressData_Ref.current,
        file_name: "testing",
        file_path: Var_ProfileImg_Ref.current?.split("?")[0],
        selfDescription: Var_Self_Ref.current,
        qualification: Var_Qauli_Ref.current,
        nationalityId: Var_Nation_Ref.current,
        website: Var_WebsiteData_Ref.current,
        dob: Var_DOB.current,
        languages: Var_Languages_Ref.current,
        conditions: Var_Conditions_Ref.current,
        procedures: Var_Procedures_Ref.current
      };

      axiosInstance.put("doctor/editDoctorDetails", profileEditData)
        .then((response) => {
          setVar_ShowImage(!Var_ShowImage);
          setVar_ProfileSuccessfully("Profile updated successfully.");
          setVar_IsShowSuccess(true);
          setTimeout(() => {
            setVar_IsShowSuccess(false);
            getDoctorProfile();
            handleOnClick("");
          }, 3000);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    }
  };
  //Edit Profile Details List end

  const getPharmacyDetials = () => {
    const payloadData = {
      Doctorid: Cookies.get("clinic_id") || Cookies.get("Clinic_id"),
    };
    axiosInstance.post("doctor/getPharmadetails", payloadData)
      .then((response) => {
        const data = response.data?.data;
        if (Array.isArray(data) && data.length > 0) {
          setVar_PharmacyDetials(data[0]);
        }
        setVar_pharmdataSelect({
          vendor_name: "Select Pharmacy",
          pharmacyId: "",
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChange = (event) => {
    setDOB(event.target.value); // Updates both state and ref
  };

  const getPharmacyValue = (event) => {
    setVar_pharmdataSelect(event.target.value);
    setVar_pharmacyId(event.target.value.pharmacy_id);
  };

  const getSpeciality = async () => {
    try {
      const docId = getDoctorId();
      if (!docId) return;
      let data = {
        doctor_id: docId,
        doctorId: docId
      };
      const response = await axiosInstance.post("doctor/getSpecialitybyDoctor", data);

      let rawData = response?.data?.data;
      if (typeof rawData === "string") {
        const aesKey = await initEncryptionSession();
        rawData = await decryptData(rawData, aesKey);
      }
      const specialityArr = Array.isArray(rawData) ? rawData : [];

      setVar_GetServiceList(specialityArr);

      const firstSpeciality = specialityArr.length > 0 ? specialityArr[0] : null;

      if (firstSpeciality) {
        setVar_SpecialityValueId({
          id: firstSpeciality.specialityId || firstSpeciality.id,
          speciality: firstSpeciality.speciality || firstSpeciality.speciality_name || firstSpeciality.name
        });
      }
    } catch (error) {
      console.log("Speciality error:", error);
    }
  };

  const editWebPremissions = async () => {
    setLoading(true);
    const docId = getDoctorId();
    const requestData = {
      doctorId: docId,
      clinicId: Cookies.get("Clinic_id") || Cookies.get("clinic_id"),
      referralAccess: 0,
      prescriptionAccess: 0,
      reportAccess: 0,
      historyAccess: 0,
      availabilityAccess: 0,
      postAccess: 0,
      adAccess: 0,
      dealAccess: 0,
      serviceAccess: checkboxValues.service_access == true ? 1 : 0,
      workinghrsAccess: checkboxValues.workinghrs_access == true ? 1 : 0,
      revenueAccess: checkboxValues.revenue_access == true ? 1 : 0,
      appointmentAccess: checkboxValues.appointment_access == true ? 1 : 0,
    };
    axiosInstance.post("doctor/updateClinicPermissions", requestData)
      .then((response) => {
        setLoading(false);
        if (response.data.status == 1) {
          setVar_ProfileSuccessfully("Web Access updated successfully.");
          setVar_IsShowSuccess(true);
          getWebAccessDetials();
          setTimeout(() => {
            setVar_IsShowSuccess(false);
          }, 3000);
        } else {
          setVar_ProfileSuccessfully(response.data.msg + ".");
          setVar_IsShowSuccess(true);
          setTimeout(() => {
            setVar_IsShowSuccess(false);
          }, 3000);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const getSpecialityValue = (event) => {
    setVar_SpecialityValueId(event.target.value);
  }
  const openWebAccess = () => {
    setisshowWebAccess(!isshowWebAccess);
  }
  const getCheckBoxValue = (event, value) => {
    setcheckboxValues((prev) => ({
      ...prev,
      [value]: event.target.checked,
    }));
  }
  const insertDOB = (event) => {
    setDOB(event.target.value);
  }
  const formatDate = (dateString) => {
    const options = { year: '2-digit', month: 'short', day: '2-digit' };
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', options).replace(',', '');
  }

  return (
    <div>
      {loading && (
        <div className="loader_body">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress size={32} />
          </Box>
        </div>
      )}

      <div className="space-y-2.5 animate-in fade-in duration-300 w-full text-gray-800">
            {/* Header Card */}
            <div className="bg-white px-4 py-2.5 rounded-lg border border-gray-200 shadow-2xs flex items-center gap-2.5">
              <button
                onClick={() => handleOnClick("/")}
                className="p-1 hover:bg-gray-100 rounded text-gray-400 transition-colors border-none bg-transparent cursor-pointer"
                title="Back"
              >
                <HiOutlineChevronLeft size={18} />
              </button>
              <div>
                <h2 className="text-sm font-bold text-gray-800 leading-tight m-0">Doctor Profile</h2>
                <p className="text-gray-400 text-[11px] m-0 font-medium">Manage your professional information and preferences</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-start">
              {/* Left Column: Avatar & Quick Info & Documents */}
              <div className="lg:col-span-1 space-y-3">
                <div className="bg-white p-3.5 rounded-lg border border-gray-200 shadow-2xs flex flex-col items-center text-center">
                  <div className="relative group mb-2">
                    <div className="w-20 h-20 rounded-lg overflow-hidden border border-teal-100 shadow-2xs">
                      <img
                        src={Var_ProfileImg || Var_ProfileImg_Ref.current || Var_Profiledata?.[0]?.vendor_profile_path || vector}
                        className="w-full h-full object-cover"
                        alt="Profile"
                      />
                    </div>
                    <label
                      htmlFor="profile-upload"
                      className="absolute -bottom-1 -right-1 w-6 h-6 bg-gray-900 text-white rounded-md flex items-center justify-center cursor-pointer shadow-2xs hover:bg-teal-600 transition-all active:scale-95"
                    >
                      <img src={add_icon} className="w-3 h-3 invert" alt="Upload" />
                    </label>
                    <input id="profile-upload" type="file" className="hidden" onChange={uploadDocument} />
                  </div>

                  {Var_Profiledata?.[0] && (
                    <>
                      <h3 className="text-xs font-bold text-gray-800 leading-snug m-0">
                        {Var_TitleType ? `${Var_TitleType} ` : ''}
                        {Var_Profiledata[0].doctorName || Var_Profiledata[0].doctor_name || Var_Profiledata[0].vendor_name || 'Doctor'}
                      </h3>
                      <div className="flex items-center gap-1.5 mt-1 bg-teal-50 px-2 py-0.5 rounded-md border border-teal-100">
                        <div className="w-1.5 h-1.5 rounded-full bg-teal-500" />
                        <span className="text-[10px] font-bold text-teal-700 uppercase tracking-wider">
                          {typeof Var_SpecialityValueId === 'string'
                            ? (Var_SpecialityValueId || 'Medical Professional')
                            : (Var_SpecialityValueId?.speciality || 'Medical Professional')}
                        </span>
                      </div>
                      {Var_RegNo && (
                        <div className="text-[10px] text-gray-500 font-medium mt-1">
                          Reg No: <span className="font-semibold text-gray-700">{Var_RegNo}</span>
                        </div>
                      )}
                      {Var_Experience && (
                        <div className="text-[10px] text-teal-600 font-medium">
                          {Var_Experience} Years Experience
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Uploaded Documents / Certificates Card */}
                <div className="bg-white p-3.5 rounded-lg border border-gray-200 shadow-2xs">
                  <div className="flex items-center justify-between pb-1.5 mb-2 border-b border-gray-100">
                    <h4 className="text-xs font-bold text-gray-800 flex items-center gap-1.5 m-0">
                      <div className="w-5 h-5 rounded bg-teal-50 text-teal-600 flex items-center justify-center">
                        <HiOutlineDocumentText size={13} />
                      </div>
                      Documents & Licenses
                    </h4>
                  </div>
                  <div className="space-y-2 text-xs">
                    {[
                      { label: "Medical License", url: Var_Documents?.license },
                      { label: "Authorized Signature", url: Var_Documents?.authorizedSignature },
                      { label: "Commercial License", url: Var_Documents?.commercialLicense },
                      { label: "Civil ID", url: Var_Documents?.civilId },
                    ].map((doc, idx) => (
                      <div key={idx} className="flex items-center justify-between p-1.5 rounded bg-gray-50 border border-gray-100">
                        <span className="text-[11px] font-medium text-gray-700">{doc.label}</span>
                        {doc.url ? (
                          <a
                            href={doc.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-teal-600 hover:text-teal-700 flex items-center gap-1 text-[11px] font-semibold hover:underline"
                          >
                            <HiOutlineExternalLink size={12} /> View
                          </a>
                        ) : (
                          <span className="text-gray-400 text-[10px] italic">Not uploaded</span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Right Column: Detailed Forms & Conditions/Procedures */}
              <div className="lg:col-span-2 space-y-3">
                {/* Credentials & Details Card */}
                <div className="bg-white p-3.5 rounded-lg border border-gray-200 shadow-2xs">
                  <div className="flex items-center justify-between mb-2.5 pb-1.5 border-b border-gray-100">
                    <h4 className="text-xs font-bold text-gray-800 flex items-center gap-2 m-0">
                      <div className="w-5 h-5 rounded bg-teal-50 text-teal-600 flex items-center justify-center">
                        <HiOutlineUser size={13} />
                      </div>
                      Professional & Practice Details
                    </h4>
                    <div className="text-[10px] text-gray-400 font-semibold italic">
                      Last synced: {moment().format('hh:mm A')}
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3 gap-y-2.5">
                    {/* Title */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Title</label>
                      <select
                        value={Var_TitleType || "Dr."}
                        onChange={(e) => setVar_TitleType(e.target.value)}
                        className="w-full h-8 px-2 text-xs text-gray-800 bg-white border border-gray-300 rounded-md focus:border-teal-500 focus:outline-none"
                      >
                        <option value="Dr.">Dr.</option>
                        <option value="Prof.">Prof.</option>
                        <option value="Assoc. Prof.">Assoc. Prof.</option>
                        <option value="Asst. Prof.">Asst. Prof.</option>
                        <option value="Mr.">Mr.</option>
                        <option value="Ms.">Ms.</option>
                        <option value="Mrs.">Mrs.</option>
                      </select>
                    </div>

                    {/* Specialty (read-only) */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Specialty</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={typeof Var_SpecialityValueId === 'string'
                          ? Var_SpecialityValueId
                          : (Var_SpecialityValueId?.speciality || '')}
                        InputProps={{
                          readOnly: true,
                          style: { borderRadius: '0.375rem', height: '32px', background: '#fafafa', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#f1f5f9' } }}
                      />
                    </div>

                    {/* Registration Number */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Registration Number</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="e.g. MED-12345"
                        value={Var_RegNo || ''}
                        onChange={(e) => setVar_RegNo(e.target.value)}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* Experience (Years) */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Experience (Years)</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="e.g. 5"
                        value={Var_Experience || ''}
                        onChange={(e) => setVar_Experience(e.target.value.replace(/\D/g, ''))}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* Qualification */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Qualification</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="e.g. MBBS, MD (General Medicine)"
                        value={Var_Quali || ''}
                        onChange={(e) => setVar_Quali(e.target.value)}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* Gender */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Gender</label>
                      <select
                        value={Var_Gender || ""}
                        onChange={(e) => setVar_Gender(e.target.value)}
                        className="w-full h-8 px-2 text-xs text-gray-800 bg-white border border-gray-300 rounded-md focus:border-teal-500 focus:outline-none"
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    {/* Work Email (read-only) */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Work Email</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="email@example.com"
                        value={Var_EmailData || Var_EmailData_Ref.current || ''}
                        InputProps={{
                          readOnly: true,
                          style: { borderRadius: '0.375rem', height: '32px', background: '#fafafa', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#f1f5f9' } }}
                      />
                    </div>

                    {/* Contact Phone */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Phone Number</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={Var_MobileData || Var_MobileData_Ref.current || ''}
                        onChange={(e) => setVar_MobileData(e.target.value.replace(/\D/g, ''))}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* Location / Area */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Location / Area</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="e.g. Salmiya, Kuwait City"
                        value={Var_Location || ''}
                        onChange={(e) => setVar_Location(e.target.value)}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* Practice / Clinic Address */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Practice Address</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Complete clinical address..."
                        value={Var_AddressData || Var_AddressData_Ref.current || ""}
                        onChange={(e) => setVar_AddressData(e.target.value)}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* Languages Spoken */}
                    <div className="space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">Languages Spoken</label>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="e.g. English, Hindi, Tamil"
                        value={Var_Languages || ''}
                        onChange={(e) => setVar_Languages(e.target.value)}
                        InputProps={{
                          style: { borderRadius: '0.375rem', height: '32px', fontSize: '12px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>

                    {/* About / Bio (Full Width) */}
                    <div className="md:col-span-2 space-y-0.5">
                      <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider">About Doctor</label>
                      <TextField
                        fullWidth
                        multiline
                        rows={2}
                        variant="outlined"
                        placeholder="Brief description about your background, specializations, and patient care approach..."
                        value={Var_Self || ''}
                        onChange={(e) => setVar_Self(e.target.value)}
                        InputProps={{
                          style: { borderRadius: '0.375rem', fontSize: '12px', padding: '6px 10px' }
                        }}
                        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' } }}
                      />
                    </div>
                  </div>
                </div>

                {/* Conditions Treated & Procedures Performed Card */}
                <div className="bg-white p-3.5 rounded-lg border border-gray-200 shadow-2xs space-y-3">
                  <div className="flex items-center justify-between pb-1.5 border-b border-gray-100">
                    <h4 className="text-xs font-bold text-gray-800 flex items-center gap-2 m-0">
                      <div className="w-5 h-5 rounded bg-teal-50 text-teal-600 flex items-center justify-center">
                        <HiOutlineAcademicCap size={13} />
                      </div>
                      Conditions Treated & Procedures Performed
                    </h4>
                    <span className="text-[10px] text-gray-400">Add multiple items</span>
                  </div>

                  {/* Conditions Treated */}
                  <div>
                    <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider mb-1">
                      Top Conditions Treated
                    </label>
                    <div className="flex gap-2 mb-2">
                      <input
                        type="text"
                        value={conditionInput}
                        onChange={(e) => setConditionInput(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddCondition();
                          }
                        }}
                        placeholder="e.g., Diabetes, Hypertension, Asthma (press Enter to add)"
                        className="flex-1 h-8 px-2.5 text-xs text-gray-800 bg-white border border-gray-300 rounded-md focus:border-teal-500 focus:outline-none"
                      />
                      <button
                        type="button"
                        onClick={handleAddCondition}
                        className="px-3 h-8 bg-teal-600 hover:bg-teal-700 text-white text-xs font-semibold rounded-md flex items-center gap-1 transition-all cursor-pointer border-none"
                      >
                        <HiOutlinePlus size={13} /> Add
                      </button>
                    </div>

                    <div className="flex flex-wrap gap-1.5 min-h-[28px] p-2 bg-gray-50 rounded-md border border-gray-100">
                      {Var_Conditions && Var_Conditions.length > 0 ? (
                        Var_Conditions.map((cond, idx) => (
                          <span
                            key={idx}
                            className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-teal-50 text-teal-700 border border-teal-200"
                          >
                            {cond}
                            <button
                              type="button"
                              onClick={() => handleRemoveCondition(idx)}
                              className="text-teal-500 hover:text-teal-800 cursor-pointer bg-transparent border-none p-0 inline-flex items-center"
                            >
                              <HiOutlineX size={11} />
                            </button>
                          </span>
                        ))
                      ) : (
                        <span className="text-[11px] text-gray-400 italic">No conditions added yet. Type above and click Add.</span>
                      )}
                    </div>
                  </div>

                  {/* Procedures Performed */}
                  <div>
                    <label className="block text-[11px] font-bold text-gray-700 uppercase tracking-wider mb-1">
                      Procedures Performed
                    </label>
                    <div className="flex gap-2 mb-2">
                      <input
                        type="text"
                        value={procedureInput}
                        onChange={(e) => setProcedureInput(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            handleAddProcedure();
                          }
                        }}
                        placeholder="e.g., Endoscopy, ECG, Minor Surgery (press Enter to add)"
                        className="flex-1 h-8 px-2.5 text-xs text-gray-800 bg-white border border-gray-300 rounded-md focus:border-teal-500 focus:outline-none"
                      />
                      <button
                        type="button"
                        onClick={handleAddProcedure}
                        className="px-3 h-8 bg-teal-600 hover:bg-teal-700 text-white text-xs font-semibold rounded-md flex items-center gap-1 transition-all cursor-pointer border-none"
                      >
                        <HiOutlinePlus size={13} /> Add
                      </button>
                    </div>

                    <div className="flex flex-wrap gap-1.5 min-h-[28px] p-2 bg-gray-50 rounded-md border border-gray-100">
                      {Var_Procedures && Var_Procedures.length > 0 ? (
                        Var_Procedures.map((proc, idx) => (
                          <span
                            key={idx}
                            className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-50 text-cyan-700 border border-cyan-200"
                          >
                            {proc}
                            <button
                              type="button"
                              onClick={() => handleRemoveProcedure(idx)}
                              className="text-cyan-500 hover:text-cyan-800 cursor-pointer bg-transparent border-none p-0 inline-flex items-center"
                            >
                              <HiOutlineX size={11} />
                            </button>
                          </span>
                        ))
                      ) : (
                        <span className="text-[11px] text-gray-400 italic">No procedures added yet. Type above and click Add.</span>
                      )}
                    </div>
                  </div>

                  <div className="mt-2 flex items-center justify-between gap-2.5 border-t border-gray-100 pt-2.5">
                    <div className="text-[10px] font-bold text-amber-700 bg-amber-50 px-2.5 py-0.5 rounded border border-amber-100">
                      Note: Locked fields require admin approval
                    </div>
                    <button
                      onClick={editDoctorProfile}
                      className="px-4 py-1.5 bg-[#009688] hover:bg-[#00897b] text-white font-bold text-xs rounded-lg transition-all shadow-2xs active:scale-95 flex items-center gap-1.5 cursor-pointer border-none"
                    >
                      Save Changes
                    </button>
                  </div>
                </div>
              </div>
            </div>

          {/* Success Feedback Popup */}
          {Var_IsShowSuccess && (
            <div className="fixed bottom-6 right-6 z-[9999] animate-in slide-in-from-right-full duration-300">
              <div className="bg-gray-900 text-white px-4 py-3 rounded-lg shadow-xl flex items-center gap-3 border border-gray-800">
                <div className="w-7 h-7 bg-teal-500/20 rounded-md flex items-center justify-center border border-teal-500/30">
                  <i className="fa fa-check text-teal-400 text-xs" />
                </div>
                <div>
                  <p className="text-xs font-bold leading-none mb-0.5">Update Successful</p>
                  <p className="text-[10px] text-gray-400 font-medium">{Var_ProfileSuccessfully}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
}
export default ProfileComponent;
